/* @flow */
import React from 'react';
// $FlowIgnore
import { MdHelp } from 'react-icons/md';

export default function HelpIcon({
  style
}: Object): React.Element {
  return <MdHelp style={ style } />;
}
